import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import LegalPage from "@/pages/LegalPage";
import Admin from "@/pages/Admin";
import ContactPage from "@/pages/ContactPage";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/terms" element={<LegalPage title="Terms of Service" testid="terms-page" path="/terms" />} />
          <Route path="/privacy" element={<LegalPage title="Privacy Notice" testid="privacy-page" path="/privacy" />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#1A1424",
            border: "1px solid #2A2233",
            color: "#F4EEF7",
            borderRadius: "0",
          },
        }}
      />
    </ReactLenis>
  );
}

export default App;
